export default "__VITE_ASSET__5KLnOm8A__";